import createEventHandlers from './createEventHandlers';

import { isDynamicTestInBucket } from 'src/replicant/getters/ab';
import ab from 'src/replicant/ruleset/ab';

import { endSession } from '../actions/endSession.modifier';

export default createEventHandlers({
  onSessionEnd: async (state, _, api) => {
    await endSession(state, api);
  },
});
